import {TranslationKey} from '@enums'
import {Stack, Grid} from '@mui/material'

import React from 'react'

import {renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {useCreditDecisionViewModel} from './credit-decision-view-model'

/**
 * Credit Decision View page
 */
export function CreditDecisionViewPage() {
  const {creditDecisionFormFields, isEditButtonVisible, t, onPressBack, onPressEdit} = useCreditDecisionViewModel()

  return (
    <>
      <Stack gap={5}>
        <UIKit.BackgroundCard>
          <Grid container spacing={2}>
            {creditDecisionFormFields.map((item, index) => (
              <Grid sm={4} item key={`credit-decision-form-field-${index}`}>
                {renderFormField(item)}
              </Grid>
            ))}
          </Grid>
        </UIKit.BackgroundCard>
      </Stack>

      <ComposedComponents.FormButtons
        leftButton={{
          label: t(TranslationKey.Back),
          onClick: onPressBack,
        }}
        {...(isEditButtonVisible && {
          rightButton: {
            label: t(TranslationKey.Edit),
            onClick: onPressEdit,
          },
        })}
      />
    </>
  )
}
